import React from "react";
import "./TtscPage.css";
import BannerImage from "../Component/ChatGPT Image Nov 19, 2025, 08_15_27 PM.png"; // ✅ Replace with your actual banner image file

const TtscPage = () => {
  return (
    <div className="ttsc-page">
      {/* 🔹 Banner Section */}
      <div className="ttsc-banner">
        <img src={BannerImage} alt="TTSC Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 ttsc-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About TSSC (Telecom Sector Skill Council)
        </h2>

        <p>
          The Telecom Sector Skill Council (TSSC) is an initiative under the National Skill
          Development Corporation (NSDC) that focuses on building a highly skilled workforce for
          India’s growing telecommunications industry. TSSC aims to create standardized skill
          training frameworks and certification systems to enhance the quality and efficiency of
          telecom professionals across the country.
        </p>

        <p>
          As a recognized TSSC training partner, CPIT provides specialized programs that equip
          students with both theoretical and practical knowledge in telecom operations and
          infrastructure management. The courses include modules on mobile communication, optical
          fiber technology, network maintenance, and digital communication systems — all designed
          to meet the needs of modern telecom industries.
        </p>

        <p>
          CPIT’s TSSC-certified training ensures that learners gain a hands-on understanding of
          real-world telecom scenarios through lab sessions, simulation tools, and practical
          exercises. Students are also trained on workplace safety, equipment handling, and
          customer service, which are vital for success in the telecom field. The holistic training
          approach helps participants develop technical expertise and industry-readiness.
        </p>

        <p>
          After successful completion, students receive TSSC and NSDC-recognized certifications
          that enhance employability in telecom service providers, equipment manufacturing
          companies, and network maintenance firms. TSSC programs at CPIT empower learners to
          become skilled professionals ready to contribute to India’s rapidly expanding digital
          communication landscape.
        </p>
      </div>
    </div>
  );
};

export default TtscPage;
